import React from "react";
import useAuth from "../Hooks/useAuth";
import {useTranslation} from "react-i18next";
import keys from "../translations/keys";
import MainContainPageBlock from "./Main/MainContainPageBlock";
import UserInfoBlock from "./Main/UserInfoBlock";
import StartDotaBlock from "./Main/StartDotaBlock";
import OtherSettings from "./Main/OtherSettings";

const MainContentPage = () => {
    const {t} = useTranslation();
    const {user} = useAuth();
    const login = user?.profile.name;

    return <div className="after-login-content">
        <MainContainPageBlock className={'welcome-info'}>
            <div className="welcome-info--title">{t(keys.welcomeHi)}
                <div className="title--bold">{login}</div>
            </div>
            <div className="welcome-info--description">{t(keys.welcomeInfo)}</div>
        </MainContainPageBlock>
        <MainContainPageBlock className={'user-info'}>
            <UserInfoBlock/>
        </MainContainPageBlock>
        <MainContainPageBlock className={'start-client-block'}>
            <div className="start-client-block--info">{t(keys.downloadInfo)}</div>
            <div className="start-client-block--title">{t(keys.download)}</div>
            <div className="start-client-block--content">
                <StartDotaBlock/>
            </div>
            <img className="start-client-block--icon" src="/startBlockImage.png" alt={'start-client-block--icon'}/>
        </MainContainPageBlock>
        <MainContainPageBlock>
            <OtherSettings/>
        </MainContainPageBlock>
    </div>

}

export default MainContentPage;
